import axios from "axios";
import { del, get, post, patch,  put } from "./training_types_api_helper";
import * as url from "./training_types_url_helper";





// Get features
export const getTrainingTypes = () => get(url.GET_TRAINING_TYPES);


// Add feature
export const addNewTrainingType = (trainingType) => post(url.ADD_NEW_TRAINING_TYPE, trainingType);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

/*
export const addNewB = branch =>axios.post(url.ADD_NEW_BRANCH, branch, {
    headers: { "Content-Type": "application/json" }
  });

  */



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateTrainingType = (trainingType) => patch(`${url.UPDATE_TRAINING_TYPE}/${trainingType.id}`,  trainingType);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteTrainingType = (trainingType) => del(`${url.DELETE_TRAINING_TYPE}/${trainingType.id}`);







export {
  //getLoggedInUser,
  
  
};
